/* global introJs */

export function initOnboarding(options) {
  const container = document.querySelector('.onboarding-steps-container');
  const {
    stepOptions = [],
    onStart = () => {},
    onBeforeChange = () => {},
    onComplete = () => {},
    // Finish button (or Enter on the last step) only; onComplete also runs on skip/Escape.
    onFinish = () => {},
  } = options;
  const steps = Array.from(container.querySelectorAll('.onboarding-step')).map((element) => {
    const titleElement = element.querySelector('.onboarding-step__title');
    const stepBody = element.querySelector('.onboarding-step__body')?.innerHTML || '';
    const step = {
      intro: stepBody,
    };
    if (titleElement) {
      step.title = titleElement.innerHTML;
    }
    return step;
  });

  // Check each step element exists in DOM, skip if not present
  const validSteps = [];
  steps.forEach((step, index) => {
    const stepOption = stepOptions[index];
    if (stepOption && stepOption.element) {
      const element = document.querySelector(stepOption.element);
      if (element) {
        step.element = stepOption.element;
        step.position = stepOption.position;
        validSteps.push(step);
      }
    } else {
      step.element = '';
      step.position = '';
      validSteps.push(step);
    }
  });

  if (validSteps.length === 0) {
    return;
  }

  introJs()
    .setOptions({
      steps: validSteps,
      tooltipClass: 'introjs-df',
      doneLabel: '<i class="fa-regular fa-check"></i>Finish',
      skipLabel: '<i class="fa-regular fa-solid fa-xmark"></i>',
      prevLabel: '<i class="fa-regular fa-arrow-left"></i>Back',
      nextLabel: 'Next<i class="fa-regular fa-arrow-right"></i>',
      disableInteraction: true,
      exitOnOverlayClick: false,
      scrollToElement: false,
      showBullets: false,
      showButtons: true,
      showProgress: false,
      showStepNumbers: true,
    })
    .onstart(onStart)
    .onbeforechange(onBeforeChange)
    .onafterchange(function (targetEl) {
      if (!targetEl) {
        return;
      }
      const helperLayer = document.querySelector('.introjs-helperLayer');
      if (helperLayer) {
        helperLayer.addEventListener('transitionend', function scrollAfterTransition() {
          helperLayer.removeEventListener('transitionend', scrollAfterTransition);
          targetEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
      } else {
        requestAnimationFrame(() => {
          targetEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
      }
    })
    .oncomplete((_step, reason) => {
      // intro.js also calls oncomplete when the X is clicked on the last step.
      if (reason !== 'skip') {
        onFinish();
      }
      onComplete();
    })
    .onexit(onComplete)
    .start();

  if ('scrollRestoration' in history) {
    history.scrollRestoration = 'manual';
  }

  window.addEventListener('popstate', (event) => {
    window.scrollTo(0, 0);
  });
}
